import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
  ViewEncapsulation,
  ElementRef
} from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import * as uuid from 'uuid';
import { SdCurrencyPipe } from '../../pipes/currency.pipe';

@Component({
  selector: 'sd-input-control',
  templateUrl: './input-control.component.html',
  styleUrls: ['../../assets/css/form.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputControlComponent implements OnDestroy, AfterViewInit {
  name = uuid.v4();
  @Input() form: NgForm;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() type: 'text' | 'number' | 'password' | 'email' | 'currency' = 'text';
  @Input() step = 0.01;

  cModel: any;
  currencyModel: any;
  private previous: Date;
  @Input() set model(value: any) {
    this.cModel = value;
    this.currencyModel = this.currencyPipe.transform(value);
    this.ref.detectChanges();
  }
  @Output() modelChange = new EventEmitter();

  // Optional
  @Input() required: boolean;
  @Input() maxlength: number;
  @Input() pattern: string;
  @Input() disabled: boolean;
  @Input() icon = 'fa fa-search';
  @Input() validator: (value: any) => string | Promise<string>;
  @Input() tooltip: string | ((inputValue: string) => string);
  // tslint:disable-next-line: no-output-native
  @Output() click = new EventEmitter<any>();
  @Output() sdClick = new EventEmitter<any>();
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter<any>();
  @Output() sdChange = new EventEmitter<any>();
  @Output() sdFocus = new EventEmitter<any>();
  @Output() sdFocusForceBlur = new EventEmitter<any>();
  @Output() keyupEnter = new EventEmitter();

  @ViewChild('control') control: ElementRef;
  @ViewChild('formModel') formModel: NgModel;
  constructor(private ref: ChangeDetectorRef, private currencyPipe: SdCurrencyPipe) {
  }

  ngAfterViewInit() {
    this.form?.addControl(this.formModel);
    this.ref.detectChanges();
  }

  ngOnDestroy() {
    this.form?.removeControl(this.formModel);
  }

  reValidate = () => {
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  onChange = async (value: any) => {
    if (this.type === 'currency') {
      const delay = 500;
      this.previous = new Date();
      await new Promise(resolve => setTimeout(resolve, delay));
      const now = new Date();
      const dif = now.getTime() - this.previous.getTime();
      if (dif < delay) {
        return;
      }
      this.cModel = this.currencyToNumber(value);
      if (Number.isNaN(this.cModel)) {
        this.cModel = null;
      }
    } else {
      this.cModel = value;
    }
    this.modelChange.emit(this.cModel);
    this.change.emit(this.cModel);
    this.sdChange.emit(this.cModel);
  }

  onKeyupEnter = () => {
    this.keyupEnter.emit(this.cModel);
  }

  onClick = () => {
    this.click.emit(this.cModel);
    this.sdClick.emit(this.cModel);
  }

  onFocus = () => {
    this.sdFocus.emit();
    if (this.sdFocusForceBlur.observers?.length > 0) {
      this.blur();
      this.sdFocusForceBlur.emit();
    }
  }

  blur = () => {
    $(this.control.nativeElement).trigger('blur');
  }

  private currencyToNumber = (value: any) => {
    value = (value || '').replace(/,/g, '');
    if (!value) {
      return null;
    }
    return +value;
  }
}
